module.exports = __webpack_public_path__ + "img/2.64f77789.png";